import moment from 'moment';

/**
 * Returns two arrays of Previous Posted Schedules.
 * @param {*} listPreviousPostings
 */

// TODO: Delete on Confirmation all previous posting dates are accurate
// date comes in '8/24' format, this method determines accurate year
const generateYear = (date) => {
  const startMonth = date.split('/')[0];
  const currMonth =  moment().format('M');
  const currYear = moment().format('YYYY');
  if (startMonth !== currMonth) {
    // check for sched starting in upcoming year (looking ahead at most 3-months)
    if ((currMonth === '10' && parseInt(startMonth) <= 1)
      || (currMonth === '11' && parseInt(startMonth) <= 2)
      || (currMonth === '12' && parseInt(startMonth) <= 3)
    ) {
        // date must be in upcoming year
        return currYear + 1;
    }
    // check for sched starting in previous year (looking behind at most 3-months)
    else if ((currMonth === '1' && parseInt(startMonth) >= 10)
      || (currMonth === '2' && parseInt(startMonth) >= 11)
      || (currMonth === '3' && parseInt(startMonth) >= 12)
    ) {
        // date must be in previous year
        return currYear - 1;
    }
    else {
      // months don't match but still same year
      return currYear;
    }
  }
  else {
    // months do match, thus same year
    return currYear;
  }
};


const generateListPreviousPostingsArrays = (listPreviousPostings) => {
  let previous7Days = [];
  let previous9Days = [];
  if (listPreviousPostings.previous7Days && (listPreviousPostings.previous7Days.length > 0)) {
    previous7Days = listPreviousPostings.previous7Days.map((elem) => {
      return {
        id: elem.id,
        startDate: elem.date,  // TODO: DELETE ON CONFIRMATION ==> moment(`${elem.date}/${generateYear(elem.date)}`, 'M/D/YYYY'),
        scheduleFormat: 7
      };
    });
  }
  if (listPreviousPostings.previous9Days && (listPreviousPostings.previous9Days.length > 0)) {
    previous9Days = listPreviousPostings.previous9Days.map((elem) => {
      return {
        id: elem.id,
        startDate: elem.date, // TODO: DELETE ON CONFIRMATION ==>  moment(`${elem.date}/${generateYear(elem.date)}`, 'M/D/YYYY'),
        scheduleFormat: 9
      };
    });
  }
  return {
    previous7Days,
    previous9Days
  };
};

export default generateListPreviousPostingsArrays;



// WEBPACK FOOTER //
// ./src/Components/Schedule/generateListPreviousPostingsArrays.js